<div class="cl-device-input" *ngIf="deviceInput.isVisible">
    <label *ngIf="!hideTitle" class="text-contrast">{{ deviceInput.displayText }}</label>

    <cl-split-time-input [formGroup]="deviceInputForm" [isDisabled]="!deviceInput.isEnabled" [format]="deviceInput.format" [value]="deviceInput.value"
                      [minValue]="deviceInput.minValue" [maxValue]="deviceInput.maxValue" (onUpdate)="onUpdate($event)" unit="seconds">
    </cl-split-time-input>
</div>
